import {FC, useState, useEffect, Fragment} from 'react'

type Props = {
  text: string
  textColor: string
  bgColor: string
}

const BadgeCategoryContent: FC<Props> = ({text, textColor, bgColor}) => {
  return (
    <div
      className='px-3 py-1 rounded d-inline-block fw-semibold'
      style={{color: `${textColor}`, backgroundColor: `${bgColor}`}}
    >
      {text}
    </div>
  )
}

const BadgeCategory: FC<Props> = ({text, textColor, bgColor}) => {
  return <BadgeCategoryContent text={text} textColor={textColor} bgColor={bgColor} />
}

export default BadgeCategory
